import theme from "@/styles/theme";
import { Container, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import MarkdownContent from "../MarkdownContent";
import { StrapiImageAsset } from "../StrapiImageAsset";

export const AboutGeneral = ({ content }) => {
  return (
    <>
      <Container maxWidth="xl">
        <Grid
          container
          justifyContent="center"
          sx={{
            backgroundColor: `${
              content.background_color === "lightgrey"
                ? grey[100]
                : content.background_color === "white"
                ? theme.palette.common.white
                : ""
            } !important`,
            py: 3,
            [theme.breakpoints.up("md")]: {
              pt: 12,
              pb: 6,
            },
          }}
        >
          <Grid item xs={10}>
            <Typography
              variant="h3"
              align="center"
              color="common.black"
              component="p"
              sx={{
                mb: 3,
                zIndex: "50",
                position: "relative",
                [theme.breakpoints.up("md")]: {
                  mb: 6,
                },
              }}
            >
              {content.headline}
            </Typography>
            <Grid
              container
              sx={{
                [theme.breakpoints.up("sm")]: {
                  float: "left",
                  width: "35%",
                },
                mr: 2,
                mb: 2,
              }}
            >
              <Grid item xs={12}>
                <StrapiImageAsset
                  strapiImageObject={content.image}
                  layout="responsive"
                  objectFit="contain"
                  width={160}
                  height={90}
                />
              </Grid>
            </Grid>
            <MarkdownContent input={content.content} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AboutGeneral;
